export default __webpack_public_path__ + "static/media/Jenny_Timur-517_websize_tn.519b24eb.jpg";